import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ServicesModule } from '../services/services.module';
import {
  GetTokenUseCase,
  GetUserAccessUseCase,
  GetUserMenuUseCase,
} from '.';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    ServicesModule
  ],
  providers: [
    GetUserAccessUseCase,
    GetTokenUseCase,
    GetUserMenuUseCase
  ]
})
export class UseCasesModule { }
